import m from "../../../../geodata/es2015/region/usa/ksHigh";
window.am4geodata_region_usa_ksHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/ksHigh.js
// module id = null
// module chunks = 